import type { FaireProductEntity } from "../../entity_types/product";

export const p_9abvtnfubw: FaireProductEntity = {
  token: "p_9abvtnfubw",
  type: "product",
  name: "Flamingo Time | Women's Animal Slipper Socks with Grippers",
  brandToken: "b_ca2nclcids",
  brandName: "Oooh Yeah/Sock It Up/Oooh Geez Slippers",
  imageUrl:
    "https://cdn.faire.com/fastly/5bfcd11ff3caa6cafd7d9c8ca7cd0787de745100dfb8c059b5e1c2e8e40f275c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cef4fcd320ad45361e1ef6f90a2dfba674bb92de89bcda404032ac995d1a11ad.jpeg",
    "https://cdn.faire.com/fastly/a7f49ad3704b5a607e46997bae49bc848f54a580cfdbd244d71bba1cdc17bff3.jpeg",
    "https://cdn.faire.com/fastly/b6c8cbe08b514de9ee1f1d547aa8ad099e2c8aa569988fdc97802865d1e2c34a.jpeg",
    "https://cdn.faire.com/fastly/670eec870280cdfbbd26638fbf7326db69308e49094aa6528d50f6a8ec4933fb.jpeg",
    "https://cdn.faire.com/fastly/078f9caf52cc8323f49f3693d23dab2e1a76966b4fd0689e477f6a626da9976d.jpeg",
  ],
  priceDollars: 12.99,
  description:
    "3D Funny Animal Collection\nWomen's shoe size 5 to 10. One size fits most women. \nEach pair is fully lined with soft and fluffy plush Sherpa so your feet are always warm and comfortable.\nNon-skid bottoms keep you steady, and you can wear them on the go!\nOur stylish and fashionable slipper designs decorate your everyday life. \nMashable washable\n100%polyester",
  tags: [],
  msrpDollars: 35.07,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:37.334Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
